// extracted by mini-css-extract-plugin
export default {"card":"TestimonialCard_card__ANTvS","name":"TestimonialCard_name__BBBtS","testimonial":"TestimonialCard_testimonial__ouJq5"};